import { render, staticRenderFns } from "./ApproverRuleField.vue?vue&type=template&id=4b31d85c&scoped=true&"
import script from "./ApproverRuleField.vue?vue&type=script&lang=js&"
export * from "./ApproverRuleField.vue?vue&type=script&lang=js&"
import style0 from "./ApproverRuleField.vue?vue&type=style&index=0&id=4b31d85c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31d85c",
  null
  
)

export default component.exports